export default {"src":"/_next/static/media/tasks_black.3a09bc5f.svg","height":23,"width":23};